<template>
  <div class="flex active-filters-parent">
    <vx-tooltip class="tooltip-label" position="bottom">
      <span class="active-filter-counter">
        <span>
          {{filterCounter}}
        </span>
        {{filterCounterText}}
      </span>

      <template slot="html">
        <div class="tooltip-parent">
        <h6 class="tooltip-h6">Filters</h6>
        <div class="flex whitespace-nowrap" v-if="campaignsFilterText">
          <h6 class="tooltip-title">Campaign: </h6>
          <div class="campaign-limit">
            <span class="tootltip-data campaigns-counter">
              {{ campaignsFilterText }}
            </span>
          </div>
        </div>

        <div v-if="filters.status" class="flex">
          <h6 class="tooltip-title">Status:</h6>
          <span class="tootltip-data">{{filters.status}}</span>
        </div>

        <div v-if="filters.event" class="flex">
          <h6 class="tooltip-title">Conversions:</h6>
          <span class="tootltip-data">{{ eventName }}</span>
        </div>
        </div>
      </template>
    </vx-tooltip>

    <div id="campaigns-clear-filters-button" v-on:click="$emit('clear-filters')" class="clear-filters-parent tooltip-label">
      <span class="clear-filters">
        Clear
        <vs-icon class="clear-icon" icon="speakol-cancel" icon-pack="speakol"></vs-icon>
      </span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {trim} from '@/utils/StringOperations.js'

export default {
  props: ['filterCounter', 'filters', 'filteredCampaigns'],

  computed: {
    ...mapGetters({
      pixelEvents: 'campaign/pixelEvents'
    }),

    filterCounterText () {
      return this.filterCounter === 1 ? 'Active Filter' : 'Active Filters'
    },

    eventName () {
      return this.pixelEvents.find(event => event.id === this.filters.event).label
    },

    campaignsFilterText () {
      if (this.isAllSelected()) {
        return 'All'
      }

      const filterLength = this.filteredCampaigns.length

      if (this.filteredCampaigns.length > 0) {
        //todo: Fix linting issue here ( If Fixed May Cause issue with Filter, need to test it )
        let firstCampaignName = this.filteredCampaigns.shift().name

        firstCampaignName = trim(firstCampaignName, 8)

        return filterLength === 1 ? firstCampaignName : `${firstCampaignName}+${filterLength - 1}`
      }

      return ''
    }
  },
  methods: {
    isAllSelected () {
      if (this.filteredCampaigns) {
        return this.filteredCampaigns.find(campaign => campaign.id === -1)
      }

      return false
    }
  }
}
</script>

<style scoped lang="scss">
  .active-filter-counter {
    color: rgba(44, 44, 44, 0.56);
  }

  .tooltip-label {
    margin-top: 12px;
  }

  .tooltip-parent {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .campaigns-counter {
    color: white;
    font-size: 14px;
    margin-left: 0;
    font-weight: 500;
  }

  .vs-icon {
    color: #cfcfcf;
  }

  .clear-filters-parent {
    cursor: pointer;

    .clear-filters {
      color: #0092d7;
      font-weight: 600;
      font-size: 14px;
      margin-left: 8px;
    }

    .clear-icon {
      color: #0092d7;
      margin-left: 8px;
      font-size: 13px !important;
      position: relative;
      top: 1px;
    }
  }

  .active-filters-parent {
    margin-left: 20px;
  }

  .tooltip-h6 {
    color: white;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
    margin-top: 10px;
  }

  .tooltip-title {
    color: white;
    font-weight: 200;
    line-height: 21px;
  }

  .tootltip-data {
    font-weight: 500;
    font-size: 14px;
    margin-left: 5px;
  }

  @media (max-width: 768px) {
    .active-filters-parent {
      margin-left: 0;
    }

    .tooltip-label {
      margin-top: 20px;
      margin-bottom: 18px !important;
    }
  }
</style>
